var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuotoneChart34(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40003 22.4941C5.40003 19.8512 8.95816 16.1079 13.1945 16.6783C16.1354 17.0744 15.6646 20.3198 18.6056 20.7158C22.8419 21.2863 26.4 14.9 26.4 14.9M13.1945 8.06257C8.95815 7.4921 5.40003 11.2355 5.40002 13.8784L5.40003 25.453C5.40002 25.5356 5.48976 25.6 5.60044 25.6L26.1996 25.6C26.3103 25.6 26.4 25.5331 26.4 25.4505V7.03356C26.4 6.87003 26.0794 6.81551 25.9839 6.96268C24.9269 8.59124 21.9816 12.5547 18.6056 12.1001C15.6646 11.704 16.1354 8.45861 13.1945 8.06257Z",
    stroke: "#BFBFBF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60044 25.6004L26.1996 25.6004C26.3103 25.6004 26.4 25.5334 26.4 25.4508L26.4 15.6703C26.4 15.464 26.1118 15.381 25.9998 15.5542C24.9567 17.1671 21.9987 21.1731 18.6056 20.7162C15.6646 20.3201 16.1354 17.0747 13.1945 16.6787C8.95816 16.1082 5.40003 19.8516 5.40003 22.4944L5.40002 25.4533C5.40002 25.5359 5.48975 25.6004 5.60044 25.6004Z",
    stroke: "#CE375C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuotoneChart34);
export default __webpack_public_path__ + "static/media/duotone - chart 34.36b8f0052d9048872f73ff92a4b5b2de.svg";
export { ForwardRef as ReactComponent };